/** Canonical LOAMIFY brand mark (`--brand-mark` in design tokens). */
export const MARKETING_DEFAULT_PUBLICATION_BRAND_COLOR = '#FF8025';

export function resolveMarketingPublicationBrandColor(brandColor?: string | null): string {
  const trimmed = brandColor?.trim();
  return trimmed || MARKETING_DEFAULT_PUBLICATION_BRAND_COLOR;
}
